
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Remove dark mode class addition
createRoot(document.getElementById("root")!).render(<App />);

// Register the service worker so the app is installable on iOS & Android
// (Add to Home Screen). The SW is SPA-aware + network-first for navigations and
// never caches Supabase/API traffic, so the installed app always reflects the
// live backend — the single source of truth shared with the website.
//
// We force an update check on load and auto-activate any new SW so users who
// previously cached the broken "/app" 404 immediately pick up the fix.
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Check for an updated SW (purges the old cache that held the /app 404).
        registration.update().catch(() => {});
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            // A new SW is installed and there is an existing controller -> activate it.
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              newWorker.postMessage?.('skipWaiting');
            }
          });
        });
      })
      .catch(() => {
        /* no-op: app still works without offline support */
      });
  });
}
